import React, { useState } from 'react';
import { Box, Flex, IconButton, Text, Button, Heading, HStack } from '@chakra-ui/react';
import LikeImagesGallery from './LikeImagesGallery';
import ChatBox from './ChatBox';
import { useAuth } from '../contexts/AuthContext';
import { useParams } from 'react-router-dom';
import { ChatIcon } from '@chakra-ui/icons';
import { useNavigate } from 'react-router-dom';

const LikeImagesWithChat = () => {
  const { currentUser, isFunctionEnabled } = useAuth();
  if (!currentUser) return null;
  const [isChatOpen, setIsChatOpen] = useState(true);
  const { targetUserId } = useParams();
  const navigate = useNavigate();
  const handleToggle = () => {
    setIsChatOpen(!isChatOpen);
  };
  return (
    <Flex gap={8} p={4} w="100vw" direction="column" minH="100vh">
      <HStack>
        <Button onClick={() => navigate(-1)} colorScheme="gray" variant="outline">← 戻る</Button>
        <Heading>お気に入り画像</Heading>
      </HStack>
       <Box 
            bg="gray.100"
            p={4}
            borderRadius="md"
            w="100%"
        >
            <Text>
                好きな画像をアップロードして、どんな外観・内観・設備が好きかイメージを共有しましょう！
            </Text>
        </Box>
      <Box w="100%">
        <LikeImagesGallery />
      </Box>
      {/* チャット機能が有効な場合のみ表示 */}
      {isFunctionEnabled('chat') && (
        <>
          <IconButton
                icon={<ChatIcon boxSize="30px" />}
                onClick={handleToggle}
                aria-label={isChatOpen ? "チャットを折りたたむ" : "チャットを展開する"}
                size="sm"
                variant="ghost"
                position="fixed"
                right={"30px"}
                top="30px"
                transform="translateY(-50%)"
                zIndex={20}
                bg="white"
                _hover={{ bg: "gray.100" }}
                boxShadow="sm"
              />
          <Box 
                w={isChatOpen ? "400px" : "0"}
                h="100vh"
                position="fixed" // オーバーレイ表示のため fixed に変更
                top="0" // 親要素の上端に合わせる
                right="0" // 親要素の右端に合わせる
                transition="width 0.3s ease-in-out"
                overflowY="auto" // 内容が多い場合にスクロール可能にする
                zIndex={10} // 他の要素より手前に表示
                bg="white"
                borderWidth="1px"
              >
            <ChatBox itemType="like_images" targetUserId={targetUserId} isOpen={isChatOpen} />
          </Box>
        </>
      )}
    </Flex>
  );
};

export default LikeImagesWithChat; 